import { render, staticRenderFns } from "./errore.vue?vue&type=template&id=5b5920f3&"
import script from "./errore.vue?vue&type=script&lang=js&"
export * from "./errore.vue?vue&type=script&lang=js&"
import style0 from "./errore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports